import React, { useContext, useEffect, useState } from "react";
import CrosstabModal from "../components/DashboardBuilder/CrosstabModal";
import VariableContext from "../contexts/VariableContext";
import FetchingFreq from "../contexts/FetchingFreq";

export default function CrosstabPage() {
  const {
    dataGroup,
    crosstabSelectedVars,
    setCrosstabSelectedVars,
  } = useContext(VariableContext);

  const { setActivePage } = useContext(FetchingFreq);
  const [crosstabDisplayData, setCrosstabDisplayData] = useState(null);

  useEffect(() => {
    setActivePage("crosstabmodel");
  }, []);

  useEffect(() => {
    if (dataGroup && Object.keys(dataGroup).length > 0) {
      setCrosstabSelectedVars(Object.keys(dataGroup));
    }
  }, [dataGroup]);

  return (
    <div>
      <CrosstabModal
        selectedVars={crosstabSelectedVars}
        crosstabDisplayData={crosstabDisplayData}
        setCrosstabDisplayData={setCrosstabDisplayData}
      />
    </div>
  );
}

